import { ReactElement } from 'react'
import styles from '../styles/StageTitle.module.css'

interface Props {
  children: ReactElement | string
  small?: boolean
}

const StageTitle = ({ children, small }: Props): ReactElement => {
  return (
    <div className={[styles.title, small === true && styles.small].join(' ')}>
      {children}
    </div>
  )
}

export default StageTitle
